import { render, staticRenderFns } from "./OperationalDashboard.vue?vue&type=template&id=90b4546c&scoped=true&"
import script from "./OperationalDashboard.vue?vue&type=script&lang=js&"
export * from "./OperationalDashboard.vue?vue&type=script&lang=js&"
import style0 from "./OperationalDashboard.vue?vue&type=style&index=0&id=90b4546c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b4546c",
  null
  
)

export default component.exports